import { useContext } from 'react';
import VendorContext from '../contexts/VendorContext';
import type { IVendorContext } from '../contexts/VendorContext';

const useVendor = (): IVendorContext => useContext(VendorContext);

export default useVendor;
